import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
/* eslint-disable */
const state = {
    userInfo: null,
    carts: [],
}

const getters = {
    userInfo: (state: any) => state.userInfo,
    carts: (state: any) => state.carts,
}

const mutations = {
    SET_DATA(state: any, obj: any) {
        state[obj.key] = obj.data
        sessionStorage.removeItem(obj.key)
        if (!obj.data || (Array.isArray(obj.data) && !obj.data.length)) {
            return
        }
        sessionStorage.setItem(obj.key, JSON.stringify(obj.data))
    }
}

export default new Vuex.Store({
    state,
    getters,
    mutations,
    actions: {},
    modules: {},
})
